import { GoogleDriveService } from './../../services/google-drive.service';
import { Folder, Document } from '../../models/node.class';
import { Component, Input, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { NgClass, NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-folder',
    templateUrl: './folder.component.html',
    styleUrls: ['./folder.component.scss'],
    standalone: true,
    imports: [NgClass, NgFor, NgIf]
})
export class FolderComponent implements OnDestroy {
  @Input() folder: Folder
  @Input() index: number;

  childs: (Folder|Document)[]
  open = false;
  active = false;

  private $unsubscribe = new Subject<void>();

  constructor(public gapiService: GoogleDriveService) {
    this.gapiService._activeFolders.pipe(takeUntil(this.$unsubscribe)).subscribe(list => {
      if(!list) return;
      if(!this.folder?.data) return
      this.open = list.find(el => el === this.folder.data.id) ? true : false;
    });

    this.gapiService._activeFolderId.pipe(takeUntil(this.$unsubscribe)).subscribe(id => {
      if(!this.folder?.data) return
      this.active = id === this.folder.data.id ? true : false;
    })
  }

  set(folder: (Folder|Document)[]) {
    this.childs = folder;
  }

  ngOnDestroy(): void {
    this.$unsubscribe.next();
    this.$unsubscribe.complete();
  }
}
